import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
const MultiselectToggleCounter = (props) => {
    const { customRenderer, selectedAmount, counterMessage } = props;
    if (customRenderer) {
        return customRenderer(selectedAmount);
    }
    if (counterMessage) {
        const message = selectedAmount === 1 ? counterMessage.one : counterMessage.many;
        return (_jsxs("span", { children: [_jsx("span", Object.assign({ className: 'option-counter margin-right-1' }, { children: selectedAmount })), _jsx("span", Object.assign({ className: 'counter-message margin-left-1' }, { children: message }))] }));
    }
};
export default MultiselectToggleCounter;
